export const baseUrl = process.env.REACT_APP_BASE_URL
export const RECAPTCHA_API_KEY = process.env.REACT_APP_RECAPTCHA_API_KEY
export const CRISP_WEBSITE_ID = process.env.REACT_APP_CRISP_WEBSITE_ID
export const GA4_TRACKING_ID = process.env.REACT_APP_GA4_TRACKING_ID
export const MAINTENANCE_MODE = process.env.REACT_APP_MAINTENANCE_MODE
export const INACTIVITY_TIMER = process.env.REACT_APP_INACTIVITY_TIMER
